import { render, staticRenderFns } from "./medics.vue?vue&type=template&id=b9581d92"
import script from "./medics.vue?vue&type=script&lang=js"
export * from "./medics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports